/* eslint-disable no-console */
import { generateLogMessagePrefix, logLoggerFailure } from './utils';
export const debug = (mfeName, args) => {
    const messagePrefix = generateLogMessagePrefix(mfeName, 'DEBUG');
    try {
        console.log(messagePrefix, ...args);
    }
    catch {
        logLoggerFailure('DEBUG');
    }
};
